module.exports = __webpack_public_path__ + "media/images/icons/logo-ea6f180209a2ad19c236f93a33f17cf2.svg";